var $d791c4a431b7a587$exports = {};
$d791c4a431b7a587$exports = {
    "alert": `\u{ACBD}\u{ACE0}`,
    "dismiss": `\u{BB34}\u{C2DC}`
};


export {$d791c4a431b7a587$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
